/**
 * In-app theme (after login): uses `AdminThemePreference` + `prefers-color-scheme` when set to "auto".
 *
 * External /auth pages (login, signup, forgot password): always follow the browser/OS only
 * (`prefers-color-scheme`). Manual Light/Dark does not apply there — see `Auth.jsx`.
 */

export function normalizeAdminThemePreference(isDarkModeBool, rawPref) {
  if (rawPref === "auto" || rawPref === "light" || rawPref === "dark") {
    return rawPref;
  }
  if (isDarkModeBool === true) return "dark";
  return "auto";
}

export function resolveAdminThemeDark(preference, systemPrefersDark) {
  if (preference === "dark") return true;
  if (preference === "light") return false;
  return Boolean(systemPrefersDark);
}

/** True when the user’s OS/browser is set to dark mode (used for /auth pages only). */
export function getSystemPrefersDark() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function attachSystemColorSchemeListener(handler) {
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  const fn = () => handler(mq.matches);
  if (mq.addEventListener) {
    mq.addEventListener("change", fn);
  } else {
    mq.addListener(fn);
  }
  fn();
  return () => {
    if (mq.removeEventListener) {
      mq.removeEventListener("change", fn);
    } else {
      mq.removeListener(fn);
    }
  };
}
